export default '<svg xmlns="http://www.w3.org/2000/svg" width="22" height="14" viewBox="0 0 22 14" fill="none" style="max-width: none;">\
  <rect width="22" height="14" fill="white"/>\
  <circle cx="11" cy="7" r="3.5" fill="white" stroke="var(--color)"/>\
  <path d="M5 7C5 10.3137 7.68629 13 11 13C14.3137 13 17 10.3137 17 7C17 3.68629 14.3137 1 11 1C7.68629 1 5 3.68629 5 7Z" stroke="var(--color-secondary)" stroke-miterlimit="10"/>\
</svg>'
